<template>
    <div class="banner">
        <swiper
            v-if="weiperData.length > 0"
            :options="swiperOption"
            ref="mySwiper"
        >
            <!-- slides -->
            <swiper-slide v-for="(item, index) in weiperData" :key="index"
                ><a
                    :href="item.bannerUrl"
                    :target="item.bannerUrl ? 'view_window' : ''"
                >
                    <img :src="item.picture"
                /></a>
                <p v-show="location != 2" class="messageP">
                    {{ item.remarks }}
                </p></swiper-slide
            >
            <div class="swiper-pagination fenyeqi" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            default: 1
        },
        location: {
            default: ""
        }
    },
    data() {
        return {
            swiperOption: {
                notNextTick: true,
                //循环
                loop: true,
                initialSlide: 0,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                //滑动速度
                speed: 800,
                //滑动方向
                direction: "horizontal",
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                //分页器设置
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "custom",
                    //自定义分页器样式
                    renderCustom: function(swiper, current, total) {
                        const activeColor = "#000";
                        const normalColor = "#aeaeae";
                        let color = "";
                        let paginationStyle = "";
                        let html = "";
                        for (let i = 1; i <= total; i++) {
                            if (i === current) {
                                color = activeColor;
                            } else {
                                color = normalColor;
                            }
                            paginationStyle = `background:${color};opacity:1;margin-right:10px;width:8px;height:8px;border-radius:50%;`;
                            html += `<span class="swiper-pagination-bullet" style=${paginationStyle}></span>`;
                        }
                        return html;
                    }
                }
            },
            weiperData: []
        };
    },
    created() {
        this.getSwoperData(this.type, this.location);
    },
    methods: {
        getSwoperData(type, bannerLcation) {
            this.$ajax({
                method: "post",
                url: "homePage/myBanner",
                data: {
                    type: type,
                    bannerLcation: bannerLcation
                },
                success: res => {
                    if (res.code == 200) {
                        this.weiperData = res.message;
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.banner {
    width: 1000px;
    height: 420px;
    margin: 0 auto;
    .swiper-container {
        width: 100%;
        height: 420px;
        text-align: center;
    }

    .swiper-slide {
        width: 1000px;
        height: 100%;
        position: relative;
        a {
            display: block;
            height: 100%;
            width: 100%;
        }
        .messageP {
            width: 100%;
            height: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.3);
            text-align: left;
            color: #fff;
            text-indent: 10px;
            line-height: 30px;
            overflow: hidden;
        }
    }
    .fenyeqi {
        min-width: 100px;
        bottom: 0;
        display: flex;
        height: 30px;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
    }
    img {
        width: 100%;
        height: 420px;
    }
}
// @media screen and (max-width: 1583px) {
//     .banner {
//         width: 900px;
//         height: 283px;
//          .swiper-container {
//              height: 283px;
//          }
//          .swiper-slide {
//              height: 283px;
//              img {
//                  height: 283px;
//              }
//          }
//     }
// }

</style>


// WEBPACK FOOTER //
// src/components/common/eazyswiper.vue